import { Box, Button, Container, Grid, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react'
// import TrackVisibility from 'react-on-screen';
import { data } from '../utils/data';


const useStyles = makeStyles ((theme) => ({
  projects: {
    // height: "100vh",
    backgroundColor: "#fff",
    padding: '40px 0 180px',
    position: 'relative',
    // border: "1px solid yellow"
  },
  navPills: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '72%',
    margin: '0 auto',
    borderRadius: '50px',
    border: '2px solid #000',
    overflow: 'hidden',
    marginBottom: '40px'
  },
  TabUpdate: { 
    fontFamily: 'Inter',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    fontSize: '12px',
    height: "50px",
    width: "55%",
    padding: '0', 
    color: '#000',
    fontWeight: '700',
    letterSpacing: '0.75px',
    borderRadius: '0',

  },
  TabActive: {
    fontFamily: 'Inter',
    background: '#fca311',
    // border: '1px solid #000',
    height: "50px",
    width: "55%",
    color: '#000',
    // '&:hover': {backgroundColor: '#fff', color: '#000'}, 
    // '&.active': {color: '#000', background: '#fff'},
    // '&:focus': {color: '#000', background: '#fff'},
    // '&:selected': {color: '#000', background: 'orange'}
  },
  tabsContent: {
    marginTop: '20px'
  },
  drawContent: {
    display: 'none'
  },
  drawActiveContent: {
    display: 'block'
  },
  
}));

const Projects = () => {
  const [value, setValue] = useState(1);

  const handleChange = (value) => {
    setValue(value)
  };

  const classes = useStyles();
  return (
    <div className={classes.projects} id='project'>
      <Container>
        <Box>
          <Box>
            {/* <TrackVisibility> */}
              {/* {({ isVisible }) =>  */}
                <div 
                // className={isVisible ? 'animate__animated animate__slideInUp' : ''}
                >
                  <Box sx={{textAlign:'center'}}>
                    <Typography variant='h2' style={{color: '#000', fontSize: '45px', fontWeight:'700', marginBottom: '20px'}}>
                      Projects
                    </Typography>
                    {/* <Typography variant='subtitle2' style={{color: '#b8b8b8', fontSize: '18px', margin: '14px auto 30px auto', letterSpacing: '0.75px', width: '56%'}}>
                      Take a look at Projects here
                    </Typography> */}
                  </Box>
                  <Box>
                    <Box className={classes.navPills}
                      // sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}
                    >
                      <Box
                        className={value === 1 ? `${classes.TabUpdate} ${classes.TabActive}` : `${classes.TabUpdate}`} 
                        onClick={() => handleChange(1)}>Portfolios</Box>
                      <Box 
                        className={value === 2 ? `${classes.TabUpdate} ${classes.TabActive}` : `${classes.TabUpdate}`}
                        onClick={() => handleChange(2)} >
                          <Link
                            href='https://drive.google.com/file/d/1ixeVMgpcuYVVnE_iktjIRQe1sWMPBRZi/view?usp=sharing' 
                            target='_blank'
                            style={{color: 'inherit', textDecoration: 'none'}}
                          >
                           Resume
                          </Link>
                        </Box>
                    </Box>

                    <Box className={classes.tabsContent}>
                      <Box className={value === 1 ? `${classes.drawContent} ${classes.drawActiveContent}` : `${classes.drawContent}`}  >
                        <Grid container rowSpacing={5} columnSpacing={{ xs: 4, sm: 4, md: 4 }}>
                          {data.ecommerce.map((content) => (
                            <Grid item key={content.id} xs={12} sm={12} md={12} lg={12} xl={12}>
                              <ProjectsCards content={content} />
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                      <Box className={value === 2 ? `${classes.drawContent} ${classes.drawActiveContent}` : `${classes.drawContent}`}  >
                        <Grid container rowSpacing={5} columnSpacing={{ xs: 4, sm: 4, md: 4 }}>
                          {/* {data.portfolio.map((content) => (
                            <Grid item key={content.id} xs={12} sm={12} md={12} lg={12} xl={12}>
                              <ProjectsCards content={content} />
                            </Grid>
                          ))} */}
                        </Grid>
                      </Box>
                    </Box>
                  </Box>
                </div>
              {/* } */}
            {/* </TrackVisibility> */}
          </Box>
        </Box>
      </Container>
    </div>
  )
}

export default Projects;

const ProjectsCards = ({content})  => {
  const {image, title, tools, style, url, ghUrl } = content;

  // const classes = useStyles();
  return (
    <Grid container spacing={{xs: '4', sm: '4', md: '2'}}>
      <Grid item xs={12} sm={12} md={6}>
        <Box 
          sx={{
            display: {xs: 'flex', sm: 'flex'}, 
            flexDirection: {xs: 'column', sm: 'row', md: 'row'}, 
            justifyContent: {xs: 'space-between', md: 'space-evenly'},  
            alignItems: 'center', 
            width: '100%',
            height: 'auto' 
          }}
        >
          <img 
            src={image} 
            alt={title} 
            width="100%"
            height="auto"
          />
        </Box>
      </Grid> 
      <Grid item xs={12} sm={12} md={6}>
        <Box 
          sx={{
            display: "flex", 
            flexDirection: "column", 
            justifyContent: 'center',
            alignItems: 'center', 
            textAlign: {xs: 'center', sm: 'start', md: 'start'},
            padding: {xs: '0px 0 0', sm: '0px 0 0', md: '50px 0 0'},
            margin: {xs: '0px 0 0', sm: '0px 0 0', md: '10px 0 0'}

          }}
        >
          <div>
          <Box sx={{textAlign: {xs: 'center', sm: 'center', md: 'start'}}}>
            <Typography variant='h4' sx={{fontFamily: 'Inter', fontWeight: '700'}}>
              {title}
            </Typography>
            <Typography variant='body1' sx={{padding: '10px 0 0', fontFamily: 'Inter', fontWeight: '500'}}>
              {tools}
            </Typography>
            <Typography variant='body1' sx={{ fontFamily: 'Inter', fontWeight: '500'}}>
              {style}
            </Typography>
          </Box>
          <Box 
            sx={{display: 'flex', 
              justifyContent: 'center', 
              alignItems: {xs: 'center', sm: 'center', md: 'start'}, 
              marginTop: '20px', 
              // textAlign: {xs: 'start !important', sm: 'center !important', md: 'start'}
            }}
          >
            <div>
              <Button variant='contained' href={url} 
                target='_blank' 
                sx={{
                  fontFamily: 'Inter',
                  fontSize: {xs: '14px', sm: '16px', md: '16px'},
                  fontWeight: '700',
                  letterSpacing: '0.85px',
                  marginRight: '28px', 
                  padding: {xs: '10px 26px', sm: '10px 30px', md: '10px 30px'},
                  background: '#fca311', 
                  color: '#000', 
                  '&:hover': {
                    background: '#000 !important',
                    color: '#fff !important',
                    backgroundColor: 'none !important',
                  }
                }}
              >
                Live site
              </Button>
            </div>
            <div>
              <Button variant='outlined' href={ghUrl}       
                target='_blank'   
                sx={{
                  fontFamily: 'Inter',
                  fontSize: {xs: '14px', sm: '16px', md: '16px'},
                  fontWeight: '700',
                  letterSpacing: '0.85px',
                  // marginRight: '40px', 
                  padding: {xs: '10px 26px', sm: '10px 30px', md: '10px 30px'},
                  border: '2px solid #fca311',
                  color: '#000', 
                  '&:hover': {
                    background: '#000 !important',
                    color: '#fff',
                    backgroundColor: 'none !important',
                    border: '0 '
                  }
                }}
              >
                Github Repo
              </Button>
            </div>
          </Box>
          </div>
        </Box>
      </Grid>   
    </Grid>
  )
}
